// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/system/login/getInfo', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取铺平路由 GET /api/currentUser */
export async function RouterAddress(options?: { [key: string]: any }) {
  return request<{
    data: any;
    code?: number;
  }>('/api/system/menu/list/tiled', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取树形路由 GET /api/currentUser */
export async function RouterAddressTree(options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>('/api/system/login/getRouters', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/system/login/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注册 POST /scm/custom-user/register */
export async function registerFrom(body: API.registerParams, options?: { [key: string]: any }) {
  return request<any>('/api/custom/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 注册短信 POST /public/sms/register */
export async function mobileCode(body?:{mobile: string }) {
  return request<any>('/message/sms/register', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: body
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** webShell POST /client/cloud/pod/ssh/ticket */
export async function getTicket(options?: { [key: string]: any }) {
  return request<API.Result>('/api/cloud/pod/ssh/ticket', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

/** 产品列表 GET /client/oms/spu/detail/list */
export async function clientSpu(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/oms/spu/detail/list', {
    method: 'GET',
    params: {
      ...(options || {}),
    },
  });
}

/** 顶级节点列表 POST /client/ims/specs/top */
export async function getregionList(options?: { [key: string]: any }) {
  return request<any>('/api/ims/region/list', {
    method: 'GET',
    params: {
      ...(options || {}),
    }
  });
}

/** 补发 POST /client/oms/order/create/order */
export async function againOrder(options?: { [key: string]: any }) {
  return request<any>('/api/oms/order/create/order', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

/** 续费 POST /oms/order/create/renew */
export async function againRenew(options?: { [key: string]: any }) {
  return request<any>('/api/oms/order/create/renew', {
    method: 'POST',
    data: {
      ...(options || {}),
    }
  });
}

export async function queryAlarmRecordPageList(params: any, options?: any) {
  return request('/api/cloud/alarm/log/page', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
